export default __webpack_public_path__ + "static/media/coach-gold.e042d0cc.svg";